import {
    HiOutlineDocumentText,
    HiOutlineDuplicate,
    HiOutlineLink,
    HiOutlineTrash,
} from 'react-icons/hi';
import { ReportingControllerBaseConfig } from '../../../../base';
import { CollectionItemController } from './collectionItemInterface';
import { CollectionItemViewProps } from './collectionItemProps';
import { DatabaseListItemPropertyProps } from '../../../../view/database-view/list';
import { HiOutlineArrowTopRightOnSquare } from 'react-icons/hi2';

export function createCollectionItemController(
    config: ReportingControllerBaseConfig
): CollectionItemController {
    const MAX_PROPERTIES = 10;
    return {
        useProps(context, item, props): CollectionItemViewProps {
            const content = item.document;
            return {
                id: content.id,
                label: content.title ?? 'Untitled',
                container: {
                    element: {
                        onMouseEnter() {
                            props.hover.onChange(true);
                        },
                        onMouseLeave() {
                            props.hover.onChange(false);
                        },
                    },
                },
                icon: content.icon
                    ? {
                          type: 'emoji',
                          emoji: content.icon,
                      }
                    : {
                          type: 'icon',
                          Component: HiOutlineDocumentText,
                      },
                open: {
                    container: {
                        onClick(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            props.onOpen();
                        },
                    },
                    button: props.hover.value
                        ? {
                              onClick(event) {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  props.onOpen();
                              },
                          }
                        : null,
                },
                menu: {
                    isVisible: props.hover.value || props.disclosure.menu.isOpen,
                    popover: {
                        isOpen: props.disclosure.menu.isOpen,
                        onClose: props.disclosure.menu.onClose,
                        onOpen: props.disclosure.menu.onOpen,
                    },
                    items: [
                        {
                            kind: 'action',
                            label: 'Open',
                            Icon: HiOutlineArrowTopRightOnSquare,
                            action: {
                                kind: 'button',
                                onClick() {
                                    props.onOpen();
                                },
                            },
                        },
                        {
                            kind: 'divider',
                        },
                        {
                            kind: 'action',
                            label: 'Copy link',
                            Icon: HiOutlineLink,
                            action: {
                                kind: 'button',
                                onClick() {
                                    props.onCopyLink();
                                },
                            },
                        },
                        {
                            kind: 'action',
                            label: 'Duplicate',
                            Icon: HiOutlineDuplicate,
                            action: {
                                kind: 'button',
                                onClick() {
                                    props.onDuplicate();
                                },
                            },
                        },
                        {
                            kind: 'action',
                            label: 'Delete',
                            colorScheme: 'red',
                            Icon: HiOutlineTrash,
                            action: {
                                kind: 'button',
                                onClick() {
                                    props.onDelete();
                                },
                            },
                        },
                    ],
                },
                properties: item.collection.properties
                    .filter(
                        (property) =>
                            // NOTE for now we the logic is to only show required, non-text fields
                            // property.required &&
                            property.type !== 'text' && property.type !== 'string'
                    )
                    .map((property) => {
                        const value = content.properties[property.key] ?? null;
                        return {
                            property,
                            value,
                        };
                    })
                    .filter(
                        ({ value }) =>
                            value !== null && value !== undefined && value !== ''
                    )
                    .slice(0, MAX_PROPERTIES)
                    .map(({ property, value }): DatabaseListItemPropertyProps => {
                        // TypeScript assertion: value cannot be null after filtering
                        const nonNullValue = value!;
                        return {
                            id: property.key,
                            property: {
                                label: property.display_name,
                                description: property.description,
                            },
                            label: nonNullValue.toString(),
                            tooltip: {
                                label: property.description,
                            },
                            value: {
                                item: {
                                    property,
                                    value: nonNullValue,
                                },
                                onChange(value) {
                                    throw new Error('onChange handler not implemented');
                                },
                            },
                        };
                    }),
            };
        },
    };
}
